export default __webpack_public_path__ + "static/media/homeScene_1.6b4e2b49.png";